import React from 'react';
import { Form } from 'react-bootstrap';
import CustomSelect from '../../Components/CustomSelect';
import { t } from '../../i18n/index';

/**
 * Component για το Zone filter dropdown με "All" checkbox
 */
const ZoneFilter = ({ zonesByWarehouse, selectedZoneId, showAllZones, language, onChangeZone, onShowAllZones }) => {
    if (!zonesByWarehouse || zonesByWarehouse.length === 0) return null;

    return (
        <div className="custom-select-wrapper slide-in-left" style={{ display: 'flex', gap: '10px' }}>
            <CustomSelect
                options={zonesByWarehouse.map(zone => ({ value: zone.ZoneId, label: zone.Descr1 }))}
                value={selectedZoneId || ""}
                placeholder={selectedZoneId ? "" : (t('truckJourney.selectZone', language) || "Select Zone")}
                onChange={onChangeZone}
            />
            <span
                onClick={onShowAllZones}
                className='all-zones-button'
            >
                <Form.Check
                    type="checkbox"
                    className='custom-checkbox'
                    checked={showAllZones}
                    onChange={onShowAllZones}
                    onClick={(e) => e.stopPropagation()}
                />
                {t('truckJourney.allButton', language) || "All"}
            </span>
        </div>
    );
};

export default ZoneFilter;
